// Components
import Text from '@components/helpers/text/Text'

const SelectionSubtitle = ({ text }: { text: string }) => {
  return (
    <Text tagName="h2" variant="title-7" spacing={{ sm: 16 }}>
      {text}
    </Text>
  )
}

export default SelectionSubtitle
